import React, { Component } from 'react';
import autosize from 'autosize';

class ExpandingTextarea extends Component {
  constructor(props) {
    super(props);
    this.timeoutId = null;
    this.textarea = null;
    this.update = this.update.bind(this);
  }
  componentDidMount() {
    // Sized before the first paint, so the content below does not move when the height is
    // applied (backlog #4 C6); updated once more after the delay, which lets autosize pick up a
    // value that arrives just after mount.
    autosize(this.textarea);
    this.timeoutId = window.setTimeout(() => {
      this.update();

      // Listen to resize events so autosize can pick up updated CSS
      // values (like max-height) when breakpoints change.
      window.addEventListener('resize', this.update);
    }, 100);
  }
  componentDidUpdate() {
    this.update();
  }
  componentWillUnmount() {
    autosize.destroy(this.textarea);
    window.clearTimeout(this.timeoutId);
    window.removeEventListener('resize', this.update);
  }
  update() {
    autosize.update(this.textarea);
  }
  render() {
    return (
      <textarea
        {...this.props}
        ref={textarea => {
          this.textarea = textarea;
        }}
      />
    );
  }
}

export default ExpandingTextarea;
